<div class="container-fluid bg-white vh-100 p-0">
    <div class="d-flex flex-column align-items-center min-vh-50">
        <div class="col-11 col-sm-10 col-md-8 col-lg-6 col-xl-5 p-3">
            <div class="d-flex align-items-center">
                <span><i class="text-muted bi bi-question-circle me-2"></i></span>
                <span class="text-muted text-xs">
                    Please provide accurate information about your income and expenses. This helps us assess your
                    financial situation and determine appropriate financing options.
                </span>
            </div>

            <div class="form-group mt-3">
                <!-- Tax Registration Section -->
                <div class="mb-4 p-3 border rounded shadow-sm">
                  <h5 class="fw-bold mb-3">Tax Registration</h5>
                  
                  <!-- Tax Registration -->
                  <div class="mb-3">
                    <div class="form-label-container min-height-seriti-form">
                      <label for="tax_registration" class="fw-bold text-xs d-block mb-2">
                        Are you registered for tax? <span class="text-danger">*</span>
                      </label>
                    </div>
                    <select 
                      v-model="client_tax_registered_ind"
                      ref="client_tax_registered_ind"
                      class="form-select rounded-small shadow-sm w-100" 
                      id="tax_registration"
                      required
                    >
                      <option value="" disabled>Please select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                    <small v-if="error_messages.client_tax_registered_ind" class="form-text text-danger text-xs fw-bold">
                      {{ error_messages.client_tax_registered_ind }}
                    </small>
                  </div>
                </div>
            </div>

            <div class="form-group mt-3">
                <!-- Monthly Income Section -->
                <div class="mb-4 p-3 border rounded shadow-sm">
                    <h5 class="fw-bold mb-3">Monthly Income</h5>

                    <!-- Source of Funds -->
                    <div class="mb-3">
                        <div class="form-label-container min-height-seriti-form">
                        <label for="funds_source" class="fw-bold text-xs d-block mb-2">
                            Source of Funds <span class="text-danger">*</span>
                        </label>
                        </div>
                        <select 
                        v-model="client_funds_source"
                        ref="client_funds_source"
                        class="form-select rounded-small shadow-sm w-100" 
                        id="funds_source"
                        required
                        >
                        <option value="" disabled>Please select</option>
                        <option v-for="option in client_funds_source_options" :key="option.value" :value="option.value">
                          {{ option.label }}
                        </option>
                        </select>
                        <small v-if="error_messages.client_funds_source" class="form-text text-danger text-xs fw-bold">
                        {{ error_messages.client_funds_source }}
                        </small>
                    </div>
                    
                    <!-- Salary Day (Full width) -->
                    <div class="mb-3">
                        <div class="form-label-container min-height-seriti-form">
                            <label for="salary_day" class="fw-bold text-xs d-block mb-2">Salary Day <span
                                    class="text-danger">*</span></label>
                        </div>
                        <input v-model="client_salary_day" ref="client_salary_day" type="number"
                            class="form-control rounded-small shadow-sm w-100" id="salary_day"
                            placeholder="Day of month (1-31)" min="1" max="31" step="1" required />
                        <small v-if="error_messages.client_salary_day" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.client_salary_day }}
                        </small>
                    </div>

                    <div class="row g-2">
                        <!-- Gross Monthly Salary -->
                        <div class="col-md-6 mb-2">
                            <div class="form-label-container min-height-seriti-form">
                            <label for="basic_salary" class="fw-bold text-xs d-block mb-2">
                                Gross monthly salary amount (R) <span class="text-danger">*</span>
                            </label>
                            </div>
                            <input 
                            v-model="client_basic_salary"
                            ref="client_basic_salary"
                            type="number"
                            class="form-control rounded-small shadow-sm w-100" 
                            id="basic_salary"
                            placeholder="0.00" 
                            step="0.01" 
                            min="0"
                            @input="calculate_tools"
                            required 
                            />
                            <small v-if="error_messages.client_basic_salary" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.client_basic_salary }}
                            </small>
                        </div>

                        <!-- Nett Salary -->
                        <div class="col-md-6 mb-2">
                            <div class="form-label-container min-height-seriti-form">
                                <label for="nett_salary" class="fw-bold text-xs d-block mb-2">Nett Salary (As on
                                    payslip) (R)
                                    <span class="text-danger">*</span></label>
                            </div>
                            <input v-model="client_nett_salary" ref="client_nett_salary" type="number"
                                class="form-control rounded-small shadow-sm w-100" id="nett_salary" placeholder="0.00"
                                step="0.01" min="0" @input="calculate_tools" required />
                            <small v-if="error_messages.client_nett_salary" class="form-text text-danger text-xs fw-bold">
                                {{ error_messages.client_nett_salary }}
                            </small>
                        </div>

                    </div>


                    <!-- Main Income Grid -->
                    <div class="row g-3">
                        <!-- Commission -->
                        <div class="col-md-4">
                            <div class="form-label-container min-height-seriti-form">
                                <label for="commission" class="fw-bold text-xs d-block mb-2">Commission (Included in
                                    Gross Monthly Salary) (R)</label>
                            </div>
                            <input v-model="client_commission" type="number"
                                class="form-control rounded-small shadow-sm w-100" id="commission" placeholder="0.00"
                                step="0.01" min="0" @input="calculate_tools" />
                            <small v-if="error_messages.client_commission" class="form-text text-danger text-xs fw-bold">
                                {{ error_messages.client_commission }}
                            </small>
                        </div>

                        <!-- Overtime -->
                        <div class="col-md-4">
                            <div class="form-label-container min-height-seriti-form">
                                <label for="overtime" class="fw-bold text-xs d-block mb-2">Overtime (Included in Gross
                                    Monthly Salary) (R)</label>
                            </div>
                            <input v-model="client_over_time" type="number"
                                class="form-control rounded-small shadow-sm w-100" id="overtime" placeholder="0.00"
                                step="0.01" min="0" @input="calculate_tools" />
                            <small v-if="error_messages.client_over_time" class="form-text text-danger text-xs fw-bold">
                                {{ error_messages.client_over_time }}
                            </small>
                        </div>
                        
                        <!-- Other Allowance -->
                        <div class="col-md-4">
                            <div class="form-label-container min-height-seriti-form">
                                <label for="other_allowance" class="fw-bold text-xs d-block mb-2">Other Allowance
                                    (Included in Gross Monthly Salary) (R)</label>
                            </div>
                            <input v-model="client_other_allowance" type="number"
                                class="form-control rounded-small shadow-sm w-100" id="other_allowance"
                                placeholder="0.00" step="0.01" min="0" @input="calculate_tools" />
                            <small v-if="error_messages.client_other_allowance" class="form-text text-danger text-xs fw-bold">
                                {{ error_messages.client_other_allowance }}
                            </small>
                        </div>
                    </div>

                    <div class="row g-3 mt-2">
                        <!-- Loan Repayments -->
                        <div class="col-md-4">
                            <div class="form-label-container min-height-seriti-form">
                                <label for="loan_repayments" class="fw-bold text-xs d-block mb-2">Loan Repayments
                                    (R)</label>
                            </div>
                            <input v-model="client_loan_repayments" type="number"
                                class="form-control rounded-small shadow-sm w-100" id="loan_deductions"
                                placeholder="0.00" step="0.01" min="0" @input="calculate_tools" />
                            <small v-if="error_messages.client_loan_repayments" class="form-text text-danger text-xs fw-bold">
                                {{ error_messages.client_loan_repayments }}
                            </small>
                        </div>

                        <!-- Settled Debt -->
                        <div class="col-md-4">
                            <div class="form-label-container min-height-seriti-form">
                                <label for="settled_debt" class="fw-bold text-xs d-block mb-2">Settled Debt (As
                                    reflects at the Credit Bureau) (R)</label>
                            </div>
                            <input v-model="client_settled_debt" type="number"
                                class="form-control rounded-small shadow-sm w-100" id="settled_debt" placeholder="0.00"
                                step="0.01" min="0" @input="calculate_tools" />
                            <small v-if="error_messages.client_settled_debt" class="form-text text-danger text-xs fw-bold">
                                {{ error_messages.client_settled_debt }}
                            </small>
                        </div>
                        
                        <!-- Rental Income -->
                        <div class="col-md-4">
                            <div class="form-label-container min-height-seriti-form">
                                <label for="rental_income" class="fw-bold text-xs d-block mb-2">Rental Income
                                    (R)</label>
                            </div>
                            <input v-model="client_rental_income" type="number"
                                class="form-control rounded-small shadow-sm w-100" id="rental_income" placeholder="0.00"
                                step="0.01" min="0" @input="calculate_tools" />
                            <small v-if="error_messages.client_rental_income" class="form-text text-danger text-xs fw-bold">
                                {{ error_messages.client_rental_income }}
                            </small>
                        </div>
                    </div>

                    <div class="row g-3 mt-2">
                        
                        <!-- Spousal/Child Support Income -->
                        <div class="col-md-4">
                            <div class="form-label-container min-height-seriti-form">
                                <label for="child_support_income" class="fw-bold text-xs d-block mb-2">Spousal/Child
                                    Support Income (R)</label>
                            </div>
                            <input v-model="client_child_maintenance" type="number"
                                class="form-control rounded-small shadow-sm w-100" id="child_support_income"
                                placeholder="0.00" step="0.01" min="0" @input="calculate_tools" />
                            <small v-if="error_messages.client_child_maintenance" class="form-text text-danger text-xs fw-bold">
                                {{ error_messages.client_child_maintenance }}
                            </small>
                        </div>
                        
                        <!-- Other Income -->
                        <div class="col-md-4">
                            <div class="form-label-container min-height-seriti-form">
                                <label for="other_income" class="fw-bold text-xs d-block mb-2">Other Income
                                    (R)</label>
                            </div>
                            <input v-model="client_other_income" type="number"
                                class="form-control rounded-small shadow-sm w-100" id="other_income" placeholder="0.00"
                                step="0.01" min="0" @input="calculate_tools" />
                            <small v-if="error_messages.client_other_income" class="form-text text-danger text-xs fw-bold">
                                {{ error_messages.client_other_income }}
                            </small>
                        </div>
                    </div>
                    
                    <!-- Other Income Source (Textarea) -->
                    <div class="mt-3 mb-3">
                        <div class="form-label-container min-height-seriti-form">
                            <label for="other_income_source" class="fw-bold text-xs d-block mb-2">Other Income Source</label>
                        </div>
                        <textarea v-model="client_other_income_source" 
                            class="form-control rounded-small shadow-sm w-100" 
                            id="other_income_source"
                            placeholder="Please describe the source of other income" 
                            rows="2"
                            maxlength="100"></textarea>
                        <small v-if="error_messages.client_other_income_source" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.client_other_income_source }}
                        </small>
                    </div>

                    <!-- Total Nett Income (Calculated Field) -->
                    <div class="mt-3">
                        <div class="p-3 bg-light rounded border">
                            <div class="form-label-container min-height-seriti-form">
                                <label for="total_nett_income" class="fw-bold text-xs d-block mb-2">Total Nett Income (R)</label>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-md-9">
                                    <input v-model="total_nett_income" type="number"
                                        class="form-control rounded-small shadow-sm w-100 bg-light" id="total_nett_income"
                                        placeholder="0.00" step="0.01" min="0" readonly />
                                </div>
                                <div class="col-sm-12 col-md-3">
                                    <span class="ms-2 text-muted text-xs"><i class="bi bi-calculator me-1"></i>Automatically calculated</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Monthly Expenses Section -->
                <div class="mb-4 p-3 border rounded shadow-sm">
                    <h5 class="fw-bold mb-3">Monthly Expenses</h5>

                    <div class="row g-3">
                        <!-- Bond/Rent Payments -->
                        <div class="col-md-4">
                            <div class="form-label-container min-height-seriti-form">
                                <label for="bond_rent" class="fw-bold text-xs d-block mb-2">Bond/Rent Payments
                                    (R)</label>
                            </div>
                            <input v-model="client_bond_rent_payments" type="number"
                                class="form-control rounded-small shadow-sm w-100" id="bond_rent" placeholder="0.00"
                                step="0.01" min="0" @input="calculate_tools" />
                            <small v-if="error_messages.client_bond_rent_payments" class="form-text text-danger text-xs fw-bold">
                                {{ error_messages.client_bond_rent_payments }}
                            </small>
                        </div>

                        <!-- Vehicle Repayments -->
                        <div class="col-md-4">
                            <div class="form-label-container min-height-seriti-form">
                                <label for="vehicle_repayments" class="fw-bold text-xs d-block mb-2">Vehicle
                                    Repayments (R)</label>
                            </div>
                            <input v-model="client_vehicle_repayments" type="number"
                                class="form-control rounded-small shadow-sm w-100" id="vehicle_repayments"
                                placeholder="0.00" step="0.01" min="0" @input="calculate_tools" />
                            <small v-if="error_messages.client_vehicle_repayments" class="form-text text-danger text-xs fw-bold">
                                {{ error_messages.client_vehicle_repayments }}
                            </small>
                        </div>

                        <!-- Credit Card Repayments -->
                        <div class="col-md-4">
                            <div class="form-label-container min-height-seriti-form">
                                <label for="credit_card" class="fw-bold text-xs d-block mb-2">Credit Card
                                    Repayments (R)</label>
                            </div>
                            <input v-model="client_credit_card_payments" type="number"
                                class="form-control rounded-small shadow-sm w-100" id="credit_card" placeholder="0.00"
                                step="0.01" min="0" @input="calculate_tools" />
                            <small v-if="error_messages.client_credit_card_payments" class="form-text text-danger text-xs fw-bold">
                                {{ error_messages.client_credit_card_payments }}
                            </small>
                        </div>
                    </div>

                    <div class="row g-3 mt-2">
                        <!-- Overdraft Repayments -->
                        <div class="col-md-4">
                            <div class="form-label-container min-height-seriti-form">
                                <label for="overdraft" class="fw-bold text-xs d-block mb-2">Overdraft Repayments
                                    (R)</label>
                            </div>
                            <input v-model="client_overdraft_payments" type="number"
                                class="form-control rounded-small shadow-sm w-100" id="overdraft" placeholder="0.00"
                                step="0.01" min="0" @input="calculate_tools" />
                            <small v-if="error_messages.client_overdraft_payments" class="form-text text-danger text-xs fw-bold">
                                {{ error_messages.client_overdraft_payments }}
                            </small>
                        </div>

                        <!-- Loan Repayments -->
                        <div class="col-md-4">
                            <div class="form-label-container min-height-seriti-form">
                                <label for="loan_repayments" class="fw-bold text-xs d-block mb-2">Loan Repayments
                                    (R)</label>
                            </div>
                            <input v-model="client_loan_repayments" type="number"
                                class="form-control rounded-small shadow-sm w-100" id="loan_repayments"
                                placeholder="0.00" step="0.01" min="0" @input="calculate_tools" />
                            <small v-if="error_messages.client_loan_repayments" class="form-text text-danger text-xs fw-bold">
                                {{ error_messages.client_loan_repayments }}
                            </small>
                        </div>

                        <!-- Furniture Accounts -->
                        <div class="col-md-4">
                            <div class="form-label-container min-height-seriti-form">
                                <label for="furniture_accounts" class="fw-bold text-xs d-block mb-2">Furniture
                                    Accounts (R)</label>
                            </div>
                            <input v-model="client_furniture_account_payments" type="number"
                                class="form-control rounded-small shadow-sm w-100" id="furniture_accounts"
                                placeholder="0.00" step="0.01" min="0" @input="calculate_tools" />
                            <small v-if="error_messages.client_furniture_account_payments"
                                class="form-text text-danger text-xs fw-bold">
                                {{ error_messages.client_furniture_account_payments }}
                            </small>
                        </div>
                    </div>

                    <div class="row g-3 mt-2">
                        <!-- Clothing Accounts -->
                        <div class="col-md-4">
                            <div class="form-label-container min-height-seriti-form">
                                <label for="clothing_accounts" class="fw-bold text-xs d-block mb-2">Clothing
                                    Accounts (R)</label>
                            </div>
                            <input v-model="client_clothing_account_payments" type="number"
                                class="form-control rounded-small shadow-sm w-100" id="clothing_accounts"
                                placeholder="0.00" step="0.01" min="0" @input="calculate_tools" />
                            <small v-if="error_messages.client_clothing_account_payments" class="form-text text-danger text-xs fw-bold">
                                {{ error_messages.client_clothing_account_payments }}
                            </small>
                        </div>

                        <!-- Insurance Payments -->
                        <div class="col-md-4">
                            <div class="form-label-container min-height-seriti-form">
                                <label for="insurance" class="fw-bold text-xs d-block mb-2">Insurance Payments
                                    (R)</label>
                            </div>
                            <input v-model="client_insurance_payments" type="number"
                                class="form-control rounded-small shadow-sm w-100" id="insurance" placeholder="0.00"
                                step="0.01" min="0" @input="calculate_tools" />
                            <small v-if="error_messages.client_insurance_payments" class="form-text text-danger text-xs fw-bold">
                                {{ error_messages.client_insurance_payments }}
                            </small>
                        </div>

                        <!-- Municipal Payments -->
                        <div class="col-md-4">
                            <div class="form-label-container min-height-seriti-form">
                                <label for="municipal" class="fw-bold text-xs d-block mb-2">Municipal Payments
                                    (R)</label>
                            </div>
                            <input v-model="client_municipal_payments" type="number"
                                class="form-control rounded-small shadow-sm w-100" id="municipal" placeholder="0.00"
                                step="0.01" min="0" @input="calculate_tools" />
                            <small v-if="error_messages.client_municipal_payments" class="form-text text-danger text-xs fw-bold">
                                {{ error_messages.client_municipal_payments }}
                            </small>
                        </div>
                    </div>

                    <div class="row g-3 mt-2">
                        <!-- Telephone Payment -->
                        <div class="col-md-4">
                            <div class="form-label-container min-height-seriti-form">
                                <label for="telephone" class="fw-bold text-xs d-block mb-2">Telephone Payment
                                    (R)</label>
                            </div>
                            <input v-model="client_telephone_payments" type="number"
                                class="form-control rounded-small shadow-sm w-100" id="telephone" placeholder="0.00"
                                step="0.01" min="0" @input="calculate_tools" />
                            <small v-if="error_messages.client_telephone_payments" class="form-text text-danger text-xs fw-bold">
                                {{ error_messages.client_telephone_payments }}
                            </small>
                        </div>

                        <!-- Transport Costs -->
                        <div class="col-md-4">
                            <div class="form-label-container min-height-seriti-form">
                                <label for="transport" class="fw-bold text-xs d-block mb-2">Transport Costs
                                    (R)</label>
                            </div>
                            <input v-model="client_transport_costs" type="number"
                                class="form-control rounded-small shadow-sm w-100" id="transport" placeholder="0.00"
                                step="0.01" min="0" @input="calculate_tools" />
                            <small v-if="error_messages.client_transport_costs" class="form-text text-danger text-xs fw-bold">
                                {{ error_messages.client_transport_costs }}
                            </small>
                        </div>

                        <!-- Food/Entertainment Costs -->
                        <div class="col-md-4">
                            <div class="form-label-container min-height-seriti-form">
                                <label for="food_entertainment" class="fw-bold text-xs d-block mb-2">Food/Entertainment
                                    Costs (R)</label>
                            </div>
                            <input v-model="client_food_entertainment_costs" type="number"
                                class="form-control rounded-small shadow-sm w-100" id="food_entertainment"
                                placeholder="0.00" step="0.01" min="0" @input="calculate_tools" />
                            <small v-if="error_messages.client_food_entertainment_costs" class="form-text text-danger text-xs fw-bold">
                                {{ error_messages.client_food_entertainment_costs }}
                            </small>
                        </div>
                    </div>

                    <div class="row g-3 mt-2">
                        <!-- Education Costs -->
                        <div class="col-md-4">
                            <div class="form-label-container min-height-seriti-form">
                                <label for="education" class="fw-bold text-xs d-block mb-2">Education Costs
                                    (R)</label>
                            </div>
                            <input v-model="client_education_costs" type="number"
                                class="form-control rounded-small shadow-sm w-100" id="education" placeholder="0.00"
                                step="0.01" min="0" @input="calculate_tools" />
                            <small v-if="error_messages.client_education_costs" class="form-text text-danger text-xs fw-bold">
                                {{ error_messages.client_education_costs }}
                            </small>
                        </div>

                        <!-- Security Payments -->
                        <div class="col-md-4">
                            <div class="form-label-container min-height-seriti-form">
                                <label for="security" class="fw-bold text-xs d-block mb-2">Security Payments
                                    (R)</label>
                            </div>
                            <input v-model="client_security_payments" type="number"
                                class="form-control rounded-small shadow-sm w-100" id="security" placeholder="0.00"
                                step="0.01" min="0" @input="calculate_tools" />
                            <small v-if="error_messages.client_security_payments" class="form-text text-danger text-xs fw-bold">
                                {{ error_messages.client_security_payments }}
                            </small>
                        </div>

                        <!-- Household Expenses -->
                        <div class="col-md-4">
                            <div class="form-label-container min-height-seriti-form">
                                <label for="household" class="fw-bold text-xs d-block mb-2">Household Expenses
                                    (R)</label>
                            </div>
                            <input v-model="client_house_hold_expenses" type="number"
                                class="form-control rounded-small shadow-sm w-100" id="household" placeholder="0.00"
                                step="0.01" min="0" @input="calculate_tools" />
                            <small v-if="error_messages.client_house_hold_expenses" class="form-text text-danger text-xs fw-bold">
                                {{ error_messages.client_house_hold_expenses }}
                            </small>
                        </div>
                    </div>

                    <div class="row g-3 mt-2">
                        <!-- Other Payments -->
                        <div class="col-md-4">
                            <div class="form-label-container min-height-seriti-form">
                                <label for="other_payments" class="fw-bold text-xs d-block mb-2">Other Payments
                                    (R)</label>
                            </div>
                            <input v-model="client_other_payments" type="number"
                                class="form-control rounded-small shadow-sm w-100" id="other_payments"
                                placeholder="0.00" step="0.01" min="0" @input="calculate_tools" />
                            <small v-if="error_messages.client_other_payments" class="form-text text-danger text-xs fw-bold">
                                {{ error_messages.client_other_payments }}
                            </small>
                        </div>
                    </div>
                </div>

                <!-- Summary Section -->
                <div class="mb-4 p-3 border rounded shadow-sm">
                    <h5 class="fw-bold mb-3">Financial Summary</h5>

                    <!-- Total Nett Income -->
                    <div class="mb-3">
                        <div class="p-3 bg-light rounded border">
                            <div class="form-label-container min-height-seriti-form">
                                <label for="summary_nett_income" class="fw-bold text-xs d-block mb-2">Total Nett Income (R)</label>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-md-9">
                                    <input v-model="total_nett_income" type="number"
                                        class="form-control rounded-small shadow-sm w-100 bg-light" id="summary_nett_income"
                                        placeholder="0.00" step="0.01" min="0" readonly />
                                </div>
                                <div class="col-sm-12 col-md-3">
                                    <span class="ms-2 text-muted text-xs"><i class="bi bi-cash-stack me-1"></i>Automatically calculated</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Total Monthly Expenses -->
                    <div class="mb-3">
                        <div class="p-3 bg-light rounded border">
                            <div class="form-label-container min-height-seriti-form">
                                <label for="total_expenses" class="fw-bold text-xs d-block mb-2">Total Monthly Expenses (R)</label>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-md-9">
                                    <input v-model="total_expenses" type="number"
                                        class="form-control rounded-small shadow-sm w-100 bg-light" id="total_expenses"
                                        placeholder="0.00" step="0.01" min="0" readonly />
                                </div>
                                <div class="col-sm-12 col-md-3">
                                    <span class="ms-2 text-muted text-xs"><i class="bi bi-cart-fill me-1"></i>Automatically calculated</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Disposable Income -->
                    <div>
                        <div class="p-3 bg-light rounded border">
                            <div class="form-label-container min-height-seriti-form">
                                <label for="disposable_income" class="fw-bold text-xs d-block mb-2">Disposable Monthly Income (R)</label>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-md-9">
                                    <input v-model="disposable_income" type="number"
                                        class="form-control rounded-small shadow-sm w-100 bg-light" id="disposable_income"
                                        placeholder="0.00" step="0.01" readonly />
                                </div>
                                <div class="col-sm-12 col-md-3">
                                    <span class="ms-2 text-muted text-xs"><i class="bi bi-wallet2 me-1"></i>Total Nett Income – Total Expenses</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="text-center mb-3 mt-4">
            <button type="button" @click="$emit('previous')" class="btn btn-bg-secondary text-xs fw-bold rounded-small shadow-sm me-1">
                Previous
            </button>
            <button class="btn btn-sm bg-green text-dark rounded-small fw-bold secondary-text-dark shadow-sm"
                @click="submit_salary_details">
                Continue
            </button>
        </div>
    </div>
</div>